import {
  Box,
  Button,
  Card,
  Chip,
  Grid2,
  IconButton,
  Skeleton,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useCallback } from "react";
import { useLocation, useOutletContext } from "react-router-dom";
import AdminProfileViewCard from "./AdminProfileViewCard";
import { useSimulation } from "../../context/SimulationContext";
import { useEffect } from "react";
import { useState } from "react";
import axios from "axios";
import { Url } from "../../Api/Api";
import { getAccessToken } from "../../hooks/useLocalStorage";
import { AppImages } from "../../constants/imageConstants";
import { BackButton } from "../../constants/AlertConstants";

const AdminProfileView = () => {
  const theme = useTheme();
  const { drawerOpen } = useOutletContext();
  const drawerWidth = 10;
  const collapsedWidth = 240;

  const location = useLocation();
  const token = getAccessToken();

  const admin_Id = location.state;

  const [adminIndividualData, setAdminIndividualData] = useState([]);
  const [adminLoading, setAdminLoading] = useState(false);

  const get_Individual_AdminCall = useCallback(
    async (id) => {
      try {
        setAdminLoading(true);
        const response = await axios.get(Url.Get_Individual_Admin(id), {
          headers: { Authorization: `Bearer ${token}` },
        });
        setAdminIndividualData(response?.data || []);
      } catch (error) {
        console.error("Error fetching individual admin", error);
      } finally {
        setAdminLoading(false);
      }
    },
    [token]
  );

  console.log(adminIndividualData, "adminIndividualDatalll");

  useEffect(() => {
    if (!admin_Id) return;
    get_Individual_AdminCall(admin_Id);
  }, [admin_Id]);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          marginTop: 2,
          transition: theme.transitions.create("margin", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          marginLeft: `${drawerOpen ? drawerWidth : collapsedWidth}px`,
          ...(!drawerOpen && {
            transition: theme.transitions.create("margin", {
              easing: theme.transitions.easing.easeOut,
              duration: theme.transitions.duration.enteringScreen,
            }),
          }),
        }}
      >
        {/* <Typography variant="h4" fontWeight={300}>Admin Profile</Typography> */}

        <BackButton />

        <Card
          sx={{
            height: 170,
            borderRadius: "100px 0 0 100px",
            p: 2.5,
            mt: 2,
            background:
              "linear-gradient(90deg,rgb(81, 176, 207) 0%, rgba(100, 29, 171, 1) 90%)",
          }}
        >
          <Stack direction="row" spacing={2} alignItems="center">
            {/* Avatar / Image Skeleton */}
            {adminLoading ? (
              <Skeleton
                variant="circular"
                animation="wave"
                width={130}
                height={130}
                sx={{ bgcolor: "#C4C4C4" }}
              />
            ) : (
              <Box
                sx={{
                  width: 130,
                  height: 130,
                  borderRadius: "50%",
                  border: "2px solid white",
                  overflow: "hidden",
                }}
              >
                <img
                  alt="name"
                  src={AppImages.NoProfile}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    objectPosition: "center",
                  }}
                />
              </Box>
            )}

            {/* Text Section Skeleton */}
            <Stack>
              {adminLoading ? (
                <>
                  <Skeleton
                    variant="text"
                    animation="wave"
                    width={180}
                    height={35}
                    sx={{ bgcolor: "#C4C4C4" }}
                  />
                  <Skeleton
                    variant="text"
                    animation="wave"
                    width={80}
                    height={25}
                    sx={{ bgcolor: "#C4C4C4" }}
                  />
                  <Skeleton
                    variant="text"
                    animation="wave"
                    width={150}
                    height={25}
                    sx={{ bgcolor: "#C4C4C4" }}
                  />
                </>
              ) : (
                <>
                  <Typography
                    variant="h2"
                    color="white"
                    textTransform="capitalize"
                  >
                    {`${adminIndividualData?.[0]?.first_name ?? "-"} ${
                      adminIndividualData?.[0]?.last_name ?? ""
                    }`}
                  </Typography>

                  <Typography variant="h6" color="#e0dfdfff">
                    Admin &nbsp;&nbsp;&nbsp; | &nbsp;&nbsp;&nbsp;{" "}
                    {adminIndividualData?.[0]?.institutions?.[0]
                      ?.institutions_name ?? "-"}{" "}
                  </Typography>

                  <Typography variant="subtitle1" color="#e0dfdfff">
                    {adminIndividualData?.[0]?.email_id ?? "-"} &nbsp; |
                    &nbsp;&nbsp;
                    {adminIndividualData?.[0]?.mobile_number ?? "-"}{" "}
                    &nbsp;&nbsp;|&nbsp;&nbsp;
                    {/* {adminIndividualData?.[0]?.institutions?.[0]?.batch_name} */}
                    <Chip
                      label={`Batch Name : ${adminIndividualData?.[0]?.institutions?.[0]?.batch_name}`}
                      variant="outlined"
                      sx={{ color: "#fff" }}
                    />
                  </Typography>
                </>
              )}
            </Stack>
          </Stack>
        </Card>
        {/* <Card> */}
        <Typography
          sx={{
            fontSize: "20px",
            fontWeight: "bold",
            p: "5px 0 0 5px",
            mt: 2,
            pb: 2,
          }}
        >
          Simulation Details
        </Typography>
        <AdminProfileViewCard
          adminIndividualData={adminIndividualData}
          adminLoading={adminLoading}
        />
      </Box>
    </Box>
  );
};

export default AdminProfileView;
